/** Optional booking fee fields: empty/zero means not set (null in DB). */
export const normalizeOptionalBookingFee = (
  value: number | null | undefined
): number | null => {
  if (value == null || value <= 0) return null;
  return value;
};

export const optionalBookingFeeInputProps = (
  value: number | null | undefined
) => ({
  value: value ?? null,
});
